import AuthRepository from './AuthRepository'
import EventRepository from './EventRepository'
import ExecutionRepository from './ExecutionRepository'
import ExerciseRepository from './ExerciseRepository'
import HorseRepository from './HorseRepository'
import JudgeResultExerciseRepository from './JudgeResultExerciseRepository'
import ResultBinomialRepository from './ResultBinomialRepository'
import LevelRepository from './LevelRepository'
import RankingRepository from './RankingRepository'
import LessonRepository from './LessonRepository'
import RiderRepository from './RiderRepository'
import TenantRepository from './TenantRepository'
import TaskUserRepository from './TaskUserRepository'
import TaskRepository from './TaskRepository'
import LocationRepository from './LocationRepository'
import OffDayTypeRepository from './OffDayTypeRepository'
import OffDayRepository from './OffDayRepository'
import SearchRepository from './SearchRepository'
import PersonRepository from './PersonRepository'
import UserRepository from './UserRepository'
import ServiceRepository from './ServiceRepository'
import HistoryHorseRiderRepository from './HistoryHorseRiderRepository'
import HorseshoeWorkRepository from './HorseshoeWorkRepository'
import HorseshoeRepository from './HorseshoeRepository'
import JudgeRepository from './JudgeRepository'
import SecretaryRepository from './SecretaryRepository'
import HorseshoeTaskRepository from './HorseshoeTaskRepository'
import ExportRawRepository from './ExportRawRepository'
import DwExerciseDetailRepository from './DwExerciseDetailRepository'
import RoleRepository from './RoleRepository'

const repositories = {
  auth: AuthRepository,
  dwExerciseDetail: DwExerciseDetailRepository,
  event: EventRepository,
  execution: ExecutionRepository,
  exercise: ExerciseRepository,
  exportRaw: ExportRawRepository,
  historyHorseRider: HistoryHorseRiderRepository,
  horse: HorseRepository,
  horseshoe: HorseshoeRepository,
  horseshoeTask: HorseshoeTaskRepository,
  horseshoeWork: HorseshoeWorkRepository,
  judgeResultExercise: JudgeResultExerciseRepository,
  judge: JudgeRepository,
  level: LevelRepository,
  lesson: LessonRepository,
  location: LocationRepository,
  offDayType: OffDayTypeRepository,
  offDay: OffDayRepository,
  person: PersonRepository,
  ranking: RankingRepository,
  resultsBinomial: ResultBinomialRepository,
  rider: RiderRepository,
  role: RoleRepository,
  secretary: SecretaryRepository,
  search: SearchRepository,
  service: ServiceRepository,
  task: TaskRepository,
  taskUser: TaskUserRepository,
  tenant: TenantRepository,
  user: UserRepository
}

export const RepositoryFactory = {
  get: name => repositories[name]
}
